import {
  COOKIE_PREFIX,
  CURRENT_ORGANISATION_ID_COOKIE_SUFFIX,
  CURRENT_USER_ID_COOKIE_SUFFIX,
  SESSION_COOKIE_SUFFIX,
  CURRENT_PROVIDER_COOKIE_SUFFIX,
} from '@ruminati/constants'
import { type AppEnvT } from '@ruminati/types_v2/env'

export function getCookieNameForEnvBySuffix(
  cookieSuffix:
    | typeof CURRENT_USER_ID_COOKIE_SUFFIX
    | typeof CURRENT_ORGANISATION_ID_COOKIE_SUFFIX
    | typeof SESSION_COOKIE_SUFFIX
    | typeof CURRENT_PROVIDER_COOKIE_SUFFIX,
  envKey: AppEnvT,
) {
  return `${COOKIE_PREFIX}_${envKey === 'prod' ? '' : `${envKey}_`}${cookieSuffix}`
}

export function USER_ID_COOKIE_FOR_ENV(envKey: AppEnvT): string {
  return getCookieNameForEnvBySuffix(CURRENT_USER_ID_COOKIE_SUFFIX, envKey)
}

export function USERS_CURRENT_ORG_ID_COOKIE_FOR_ENV(envKey: AppEnvT): string {
  return getCookieNameForEnvBySuffix(CURRENT_ORGANISATION_ID_COOKIE_SUFFIX, envKey)
}

export function USERS_SESSION_COOKIE_FOR_ENV(envKey: AppEnvT): string {
  return getCookieNameForEnvBySuffix(SESSION_COOKIE_SUFFIX, envKey)
}

export function USERS_CURRENT_PROVIDER_COOKIE_FOR_ENV(envKey: AppEnvT): string {
  return getCookieNameForEnvBySuffix(CURRENT_PROVIDER_COOKIE_SUFFIX, envKey)
}

// N.B. version for new-server
type CookieSuffix =
  | typeof CURRENT_USER_ID_COOKIE_SUFFIX
  | typeof CURRENT_ORGANISATION_ID_COOKIE_SUFFIX
  | typeof SESSION_COOKIE_SUFFIX
  | typeof CURRENT_PROVIDER_COOKIE_SUFFIX
export function getFullCookieKey(cookieSuffix: CookieSuffix, env: AppEnvT) {
  return `${COOKIE_PREFIX}_${env === 'prod' ? '' : `${env}_`}${cookieSuffix}`
}
